import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e669bb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "start-screen" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "desktop" }
const _hoisted_5 = { class: "action" }
const _hoisted_6 = {
  key: 0,
  style: {"font-size":"10px"}
}
const _hoisted_7 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-start","width":"100%"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","gap":"2px","width":"50%"}
}
const _hoisted_10 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-start","width":"100%"} }
const _hoisted_11 = ["src"]
const _hoisted_12 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-start","width":"100%"} }
const _hoisted_13 = ["src"]
const _hoisted_14 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-start","width":"100%"} }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "primary-action"
}
const _hoisted_17 = ["placeholder", "onKeyup"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, " powered by Agentur Philipp ", -1))
const _hoisted_19 = {
  key: 0,
  class: "chatbot-window"
}
const _hoisted_20 = {
  key: 0,
  class: "logoContainer"
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "question" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { key: 1 }

import Company from '@/entities/domain/Company/Company';
import { PropType, computed, ref, onMounted, watch } from 'vue'
import SecondaryActionButton from './SecondaryActionButton.vue'
import ChatbotIcon from './ChatbotIcon.vue'
import { Chatbot } from '@/entities/domain/Chatbot/Chatbot';
import { Message } from '@/entities/domain/Chatbot/Message';
import { MessageTypes, MessageSender, ChatbotState, ChatbotQuizType } from '@/entities/enums/ChatbotEnums';
import getImageFromSource from '@/utils/getImageFromSouce';
import ChatWindow from './ChatWindow.vue';
import { ISecondaryAction } from '@/interfaces/Chatbot/ISecondaryAction';
import Quiz from '@/entities/domain/Quiz/Quiz';
import QuizService from '@/services/QuizService';
import AddToStyling from '@/utils/AddToStyling';
import Close from '@/components/svg/Close.vue';
import ArrowLeft from '@/components/svg/Arrow.vue';
import FirstLevelSupportChat from '../FirstLevelSupport/FirstLevelSupportChat.vue';
import FirstLevelSupport from '../FirstLevelSupport/FirstLevelSupport.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatbotWindowV3',
  props: {
    company: {
        type: Object as PropType<Company>,
        required: true,
    },
},
  emits: ["startQuiz", "hardStartQuiz", "openResult"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const chatbot = new Chatbot({
    MessageHistory: [] as Message[],
    Token: props.company.Token,
} as Chatbot)

const secondaryActions = ref([] as ISecondaryAction[])

// on initial load the state can't be hidden. It can only be hidden after user closed it once
// const currentChatbotState = ref(ChatbotState.HIDDEN)
const currentChatbotState = ref(props.company.CompanyQuizConfig.FullscreenMode ? ChatbotState.OPENED : ChatbotState.CLOSED)
const chatWindowMode = ref(false);
const inputActive = ref(false);
const showInfoMessage = ref(false);
const tasteOfferMode = ref(false);
const isExpertQuiz = ref(false);
const searchInput = ref("");

const avatar = computed(() => getImageFromSource(
    props.company.FrontendDesign?.AvatarImageUrl ??
    "@/assets/img/bot-logo.png"
))

const brandLogoImageSource = computed(() => {
    return getImageFromSource(
        props.company?.FrontendDesign?.BrandLogoImage ??
        "@/assets/img/bot-logo.png"
    );
})

const startQuiz = (hardStart?: boolean, answeredText?: string, quizId?: number) => {

    if(answeredText)
        localStorage.setItem("answeredText", answeredText);
    else localStorage.removeItem("answeredText");

    if (hardStart) emit("hardStartQuiz", quizId);
    else emit("startQuiz");
}

const getTasteOffers = () => {
    tasteOfferMode.value = true;
    chatWindowMode.value = true;
}

const openChat = () => {
    chatbot.MessageHistory.push({
        Id: chatbot.MessageHistory.length + 1,
        Text: props.company.DisplayedTexts["Was für ein Produkt suchen Sie?"],
        Type: MessageTypes.NORMAL,
        Sender: MessageSender.WILLI,
    } as Message);

    chatWindowMode.value = true;
    inputActive.value = true;
    localStorage.setItem("chatWindowOpened", "true");
}

const chatbotTexts = computed(() => {
    return props.company.DisplayedTexts;
});


const startChatQuiz = (selectedQuiz = ChatbotQuizType.Extra) => {
    const useExpertQuiz = chatbot.ExpertQuiz?.Id ? selectedQuiz === ChatbotQuizType.Expert : false;
    isExpertQuiz.value = useExpertQuiz;
    inputActive.value = false;
    chatbot.StartConversationWithQuiz(useExpertQuiz);
    chatWindowMode.value = true;
}

const openBot = () => {
    QuizService.sendEvent("Chatbot Opened", "ChatbotOpened");
    setTimeout(() => {

        if (props.company.FirstLevelSupport)
            currentChatbotState.value = ChatbotState.SUPPORT;
        else if (props.company.CompanyQuizConfig.QuizOnlyMode && props.company.FrontendDesign?.ActionButtons?.length === 0) {
            startQuiz(true)
        }
        else {
            currentChatbotState.value = ChatbotState.OPENED;
        }
    }, 100)
}

const goBack = () => {
    chatWindowMode.value = false;
    tasteOfferMode.value = false;
    chatbot.isExpertQuizSet = false;
}

onMounted(async () => {

    if (localStorage.getItem('chatbotState') === 'hidden' && props.company.CompanyQuizConfig.HideBotOnClose) {
        currentChatbotState.value = ChatbotState.HIDDEN;
    }

    if (
        props.company.CompanyQuizConfig.ExtraChatBotQuiz &&
        props.company.CompanyCode
    ) {
        const extraQuizCompany = await QuizService.getQuiz(
            props.company.CompanyCode,
            props.company.CompanyQuizConfig.ExtraChatBotQuiz
        );

        QuizService.getQuiz(props.company.CompanyCode);

        // TODO: Take Translation for selected Language
        if (extraQuizCompany?.Data?.quiz) {
            chatbot.ExtraQuiz = Quiz.createFromApiResponse(extraQuizCompany?.Data.quiz);
        }

        if (props.company.CompanyQuizConfig.ExpertQuiz) {
            const expertQuizCompany = await QuizService.getQuiz(
                props.company.CompanyCode,
                props.company.CompanyQuizConfig.ExpertQuiz
            );

            if (expertQuizCompany?.Data?.quiz)
                chatbot.ExpertQuiz = Quiz.createFromApiResponse(expertQuizCompany?.Data.quiz);
        }

        if (props.company.selectedLanguage && chatbot.ExtraQuiz)
            chatbot.ExtraQuiz = QuizService.filterQuizForLanguage(chatbot.ExtraQuiz, props.company.selectedLanguage)

        if (props.company.selectedLanguage && chatbot.ExpertQuiz)
            chatbot.ExpertQuiz = QuizService.filterQuizForLanguage(chatbot.ExpertQuiz, props.company.selectedLanguage)
    }

    if (props.company.CompanyQuizConfig.FullscreenMode)
        QuizService.sendEvent("Chatbot Opened", "ChatbotOpened");

    setTimeout(() => {
        if (
            (props.company.isQuizClosed &&
                localStorage.getItem("chatWindowOpened") !== "true" &&
                localStorage.getItem("seenInfoMessage") !== "true")
            ||
            (props.company.isQuizClosed && props.company.CompanyQuizConfig.PlayNotificationOnce)
        ) {
            // playNotification();
            showInfoMessage.value = true;
        }
    }, 2000);

    AddToStyling(`
    			#chatbot{background: linear-gradient(180deg, ${props.company.FrontendDesign?.ProductWizard?.FirstColorWave ?? "#1C1027"
        } 0%, ${props.company.FrontendDesign?.ProductWizard?.SecondColorWave ?? "#90173E"
        } 100%);}`);

    // When mounted or returnend to main page, message history should be "cleared"
    chatbot.clearHistory();

    if (props.company.CompanyQuizConfig.AutoOpenUrls?.some(el => window.location.href.includes(el))) {
        openBot();
    }

    const offerModeActive = props.company.CompanyQuizConfig.TasteOffersActive && localStorage.getItem("sessionId") && localStorage.getItem("sessionHash");

    // set secondaryActions again to have the correct language
    props.company.FrontendDesign?.ActionButtons?.map((el, index) => {
        secondaryActions.value.push({
            name: el.text,
            color: el.color,
            icon: el.image,
            action: () => startQuiz(true, el.text, el.quiz)
        })
    });
})

// *** WATCHER ***
watch(showInfoMessage, (newValue, oldValue) => {
    if (newValue) localStorage.setItem("seenInfoMessage", "true");
});

watch(props.company.DisplayedTexts, (newValue, oldValue) => {
    if (newValue) {
        secondaryActions.value.map(el => el.name = props.company.DisplayedTexts[el.name] ?? el.name);

    }
});

watch(currentChatbotState, (newValue, oldValue) => {
    if (newValue === ChatbotState.HIDDEN && props.company.CompanyQuizConfig.HideBotOnClose)
        localStorage.setItem('chatbotState', 'hidden');
});

// watch(chatWindowMode, ()=>{
//     chatbot.clearHistory();
// })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (currentChatbotState.value === _unref(ChatbotState).OPENED)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["chatbot", { fullscreen: props.company.CompanyQuizConfig.FullscreenMode }]),
          style: _normalizeStyle({
            bottom: props.company.FrontendDesign?.ProductWizard?.Bottom ?? '1em',
            right: props.company.FrontendDesign?.ProductWizard?.Right ?? '1em',
            minHeight: __props.company.CompanyQuizConfig.SuperSearchActive ? '60vh' : '40vh'
        })
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", { src: brandLogoImageSource.value }, null, 8, _hoisted_3),
              (!props.company.CompanyQuizConfig.FullscreenMode)
                ? (_openBlock(), _createBlock(Close, {
                    key: 0,
                    class: "close",
                    fill: __props.company.FrontendDesign?.ProductWizard?.FontColorSecondary,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (currentChatbotState.value = __props.company.CompanyQuizConfig.HideBotOnClose ? _unref(ChatbotState).HIDDEN : _unref(ChatbotState).CLOSED))
                  }, null, 8, ["fill"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["primary-action", { noRadius: props.company.DisplayedTexts['border_radius'] === 'false' }])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "info",
                    style: _normalizeStyle({ fontSize: props.company.FrontendDesign?.ProductWizard?.TextConventions?.primaryFontSize })
                  }, [
                    _createTextVNode(_toDisplayString(__props.company.DisplayedTexts["Wie kann ich dir heute helfen?"]) + " ", 1),
                    (props.company.FrontendDesign?.ProductWizard?.TextConventions?.sup)
                      ? (_openBlock(), _createElementBlock("sup", _hoisted_6, _toDisplayString(props.company.FrontendDesign?.ProductWizard?.TextConventions?.sup), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(props.company.DisplayedTexts["sunIcon"] !== "false" ? "☀️" : "") + " " + _toDisplayString(props.company.FrontendDesign?.ProductWizard?.TextConventions?.staricon === "true" ? "✨" :
                                "") + " " + _toDisplayString(props.company.FrontendDesign?.ProductWizard?.TextConventions?.producticon === "true" ?
                                "🍷" : ""), 1)
                  ], 4)
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: "secondary-actions",
              style: _normalizeStyle({ fontSize: props.company.FrontendDesign?.ProductWizard?.TextConventions?.secondaryFontSize, gap: '1em', width: '100%' })
            }, [
              _createElementVNode("div", {
                style: {"display":"flex","flex-direction":"column","width":"50%"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (secondaryActions.value[0].action && secondaryActions.value[0].action(...args)))
              }, [
                _createElementVNode("div", {
                  class: "secondary-action",
                  style: _normalizeStyle({ borderColor: secondaryActions.value[0]?.color })
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    (secondaryActions.value[0]?.icon)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: secondaryActions.value[0].icon,
                          style: {"height":"100%","max-height":"100px","width":"100%","aspect-ratio":"1/1"}
                        }, null, 8, _hoisted_8))
                      : _createCommentVNode("", true),
                    _createVNode(ArrowLeft, {
                      style: {"transform":"rotate(-45deg)"},
                      color: secondaryActions.value[0]?.color
                    }, null, 8, ["color"])
                  ]),
                  _createElementVNode("div", {
                    style: _normalizeStyle({color: secondaryActions.value[0]?.color, fontSize: '2.5em', fontWeight: 'bold'})
                  }, _toDisplayString(secondaryActions.value[0]?.name), 5)
                ], 4)
              ]),
              (secondaryActions.value[2])
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "secondary-action",
                      style: _normalizeStyle({ borderColor: secondaryActions.value[1]?.color }),
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (secondaryActions.value[1].action && secondaryActions.value[1].action(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        (secondaryActions.value[1]?.icon)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: secondaryActions.value[1].icon,
                              style: {"height":"100%","max-height":"50px","width":"100%","aspect-ratio":"1/1"}
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true),
                        _createVNode(ArrowLeft, {
                          style: {"transform":"rotate(-45deg)"},
                          color: secondaryActions.value[1]?.color
                        }, null, 8, ["color"])
                      ]),
                      _createElementVNode("div", {
                        style: _normalizeStyle({color: secondaryActions.value[1]?.color, fontSize: '1.5em', fontWeight: 'bold'})
                      }, _toDisplayString(secondaryActions.value[1]?.name), 5)
                    ], 4),
                    (secondaryActions.value[2])
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "secondary-action",
                          style: _normalizeStyle({ borderColor: secondaryActions.value[2]?.color }),
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (secondaryActions.value[2].action && secondaryActions.value[2].action(...args)))
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            (secondaryActions.value[2]?.icon)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: secondaryActions.value[2].icon,
                                  style: {"height":"100%","max-height":"50px","width":"100%","aspect-ratio":"1/1"}
                                }, null, 8, _hoisted_13))
                              : _createCommentVNode("", true),
                            _createVNode(ArrowLeft, {
                              style: {"transform":"rotate(-45deg)"},
                              color: secondaryActions.value[2]?.color
                            }, null, 8, ["color"])
                          ]),
                          _createElementVNode("div", {
                            style: _normalizeStyle({color: secondaryActions.value[2]?.color, fontSize: '1.5em', fontWeight: 'bold'})
                          }, _toDisplayString(secondaryActions.value[2]?.name), 5)
                        ], 4))
                      : _createCommentVNode("", true)
                  ]))
                : (!secondaryActions.value[2])
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: {"display":"flex","flex-direction":"column","width":"50%"},
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (secondaryActions.value[1].action && secondaryActions.value[1].action(...args)))
                    }, [
                      _createElementVNode("div", {
                        class: "secondary-action",
                        style: _normalizeStyle({ borderColor: secondaryActions.value[1]?.color })
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          (secondaryActions.value[1]?.icon)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: secondaryActions.value[1].icon,
                                style: {"height":"100%","max-height":"100px","width":"100%","aspect-ratio":"1/1"}
                              }, null, 8, _hoisted_15))
                            : _createCommentVNode("", true),
                          _createVNode(ArrowLeft, {
                            style: {"transform":"rotate(-45deg)"},
                            color: secondaryActions.value[1]?.color
                          }, null, 8, ["color"])
                        ]),
                        _createElementVNode("div", {
                          style: _normalizeStyle({color: secondaryActions.value[1]?.color, fontSize: '2.5em', fontWeight: 'bold'})
                        }, _toDisplayString(secondaryActions.value[1]?.name), 5)
                      ], 4)
                    ]))
                  : _createCommentVNode("", true)
            ], 4),
            (__props.company.CompanyQuizConfig.SuperSearchActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("h3", {
                    style: _normalizeStyle({ fontSize: props.company.FrontendDesign?.ProductWizard?.TextConventions?.primaryFontSize ?? '2em', margin: 0 })
                  }, _toDisplayString(__props.company.DisplayedTexts["Welches Produkt suchst du?"]), 5),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchInput).value = $event)),
                    style: {"width":"100%","margin":"1em","padding":"1em 0","border-radius":"15px","border":"1px solid #3333","text-indent":"10px","font-size":"16px"},
                    placeholder: __props.company.DisplayedTexts['Produktsuche-Vorschlag'],
                    onKeyup: _withKeys(openChat, ["enter"])
                  }, null, 40, _hoisted_17), [
                    [_vModelText, searchInput.value]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = () => openChat()),
                    style: _normalizeStyle({ fontSize: 'calc(props.company.FrontendDesign?.ProductWizard?.TextConventions?.primaryFontSize * .8)', maxWidth: 'unset', height: '40px', backgroundColor: '#333333' })
                  }, _toDisplayString(__props.company.DisplayedTexts["Super-Suche starten"]), 5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_18,
          (chatWindowMode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(ChatWindow, {
                  company: __props.company,
                  chatbot: _unref(chatbot),
                  avatar: avatar.value,
                  onCloseChatWindow: _cache[7] || (_cache[7] = () => currentChatbotState.value = _unref(ChatbotState).CLOSED),
                  "input-active": inputActive.value,
                  onChange: _cache[8] || (_cache[8] = (chatbotUpdate) => chatbot.value = chatbotUpdate),
                  onStartQuiz: _cache[9] || (_cache[9] = ($event: any) => (startQuiz())),
                  onHardStartQuiz: _cache[10] || (_cache[10] = ($event: any) => (startQuiz(true))),
                  onGoBack: goBack,
                  loadOffers: tasteOfferMode.value,
                  isExpertQuiz: isExpertQuiz.value,
                  onMessageSend: _cache[11] || (_cache[11] = () => _unref(chatbot).isExpertQuizSet = false),
                  searchInput: searchInput.value
                }, null, 8, ["company", "chatbot", "avatar", "input-active", "loadOffers", "isExpertQuiz", "searchInput"])
              ]))
            : _createCommentVNode("", true)
        ], 6))
      : (currentChatbotState.value === _unref(ChatbotState).CLOSED)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "chatbotClose",
            style: _normalizeStyle({
        bottom: props.company.DisplayedTexts.productWizard?.bottom ?? '1em',
        right: props.company.DisplayedTexts.productWizard?.right ?? '1em',
        zIndex: 2147483647
    })
          }, [
            (showInfoMessage.value && __props.company.FirstLevelSupport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(__props.company.DisplayedTexts["Wie kann ich dir helfen?"]), 1),
                    _createVNode(Close, {
                      class: "close",
                      fill: "#ffffff",
                      onClick: _cache[12] || (_cache[12] = () => showInfoMessage.value = false)
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      onClick: _cache[13] || (_cache[13] = () => { currentChatbotState.value = _unref(ChatbotState).SUPPORT_CHAT; showInfoMessage.value = false; })
                    }, " ❓ " + _toDisplayString(__props.company.DisplayedTexts["Kundenservice"]), 1),
                    _createElementVNode("button", {
                      onClick: _cache[14] || (_cache[14] = () => { currentChatbotState.value = _unref(ChatbotState).OPENED; showInfoMessage.value = false; })
                    }, "🍷 " + _toDisplayString(__props.company.DisplayedTexts["Produktberatung"]), 1),
                    _createVNode(ChatbotIcon, {
                      size: 6,
                      avatar: avatar.value,
                      "notification-count": showInfoMessage.value ? 1 : 0,
                      onClick: openBot,
                      "border-active": props.company.FrontendDesign?.ProductWizard?.TextConventions?.showIconBorder === 'true',
                      "background-color": __props.company.FrontendDesign?.ProductWizard?.IconBackgroundColor ?? __props.company.FrontendDesign?.ProductWizard?.PrimaryColor
                    }, null, 8, ["avatar", "notification-count", "border-active", "background-color"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(ChatbotIcon, {
                    size: __props.company.DisplayedTexts['avatarSize'] ? parseInt(__props.company.DisplayedTexts['avatarSize']) : 6,
                    avatar: avatar.value,
                    "notification-count": showInfoMessage.value ? 1 : 0,
                    onClick: openBot,
                    "border-active": props.company.FrontendDesign?.ProductWizard?.TextConventions?.showIconBorder === 'true',
                    "background-color": __props.company.FrontendDesign?.ProductWizard?.IconBackgroundColor ?? __props.company.FrontendDesign?.ProductWizard?.PrimaryColor ?? __props.company.FrontendDesign.PrimaryColor
                  }, null, 8, ["size", "avatar", "notification-count", "border-active", "background-color"])
                ]))
          ], 4))
        : (currentChatbotState.value === _unref(ChatbotState).SUPPORT || currentChatbotState.value === _unref(ChatbotState).SUPPORT_CHAT)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["chatbot", { fullscreen: props.company.CompanyQuizConfig.FullscreenMode }]),
              style: _normalizeStyle({
            bottom: props.company.FrontendDesign?.ProductWizard?.Bottom ?? '1em',
            right: props.company.FrontendDesign?.ProductWizard?.Right ?? '1em',
        })
            }, [
              _createVNode(FirstLevelSupport, {
                company: __props.company,
                avatar: avatar.value,
                onOpen: _cache[15] || (_cache[15] = () => currentChatbotState.value = _unref(ChatbotState).OPENED),
                onClose: _cache[16] || (_cache[16] = () => currentChatbotState.value = _unref(ChatbotState).CLOSED),
                onStartSupportChat: _cache[17] || (_cache[17] = () => currentChatbotState.value = _unref(ChatbotState).SUPPORT_CHAT)
              }, null, 8, ["company", "avatar"]),
              (currentChatbotState.value === _unref(ChatbotState).SUPPORT_CHAT)
                ? (_openBlock(), _createBlock(FirstLevelSupportChat, {
                    key: 0,
                    company: __props.company,
                    avatar: avatar.value,
                    onOpen: _cache[18] || (_cache[18] = () => currentChatbotState.value = _unref(ChatbotState).OPENED),
                    onClose: _cache[19] || (_cache[19] = () => currentChatbotState.value = _unref(ChatbotState).CLOSED),
                    onGoBack: _cache[20] || (_cache[20] = () => currentChatbotState.value = _unref(ChatbotState).SUPPORT)
                  }, null, 8, ["company", "avatar"]))
                : _createCommentVNode("", true)
            ], 6))
          : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "arrow-slide",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (currentChatbotState.value === _unref(ChatbotState).HIDDEN)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "chatbotClose arrow",
              style: _normalizeStyle({
            bottom: __props.company.FrontendDesign?.ProductWizard?.Bottom ? 'calc(' + __props.company.FrontendDesign.ProductWizard.Bottom + ' + 3.5em)' : '3.5em',
            right: __props.company.FrontendDesign?.ProductWizard?.Right ?? '1em',
            zIndex: 2147483646,
        })
            }, [
              _createVNode(ArrowLeft, {
                onClick: _cache[21] || (_cache[21] = ($event: any) => (currentChatbotState.value = _unref(ChatbotState).CLOSED)),
                style: {"height":"3em","width":"3em","transform":"rotate(180deg)"},
                color: __props.company.FrontendDesign?.ProductWizard?.SecondaryColor
              }, null, 8, ["color"])
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})